import React from 'react'
import { Breadcrumbs, makeStyles, Typography } from '@material-ui/core'
import { ChevronRight } from 'react-feather'

export const useStyles = makeStyles((theme) => ({
  breadcrumbs: {
    color: theme.palette.common.white,
    margin: theme.spacing(8),
  },
  breadcrumb: {
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    maxWidth: '12vw',
  },
}))

type Breadcrumb = {
  name: string
}

type Props = {
  breadcrumbs: Breadcrumb[]
}

export function SystemContainerBreadcrumbs({
  breadcrumbs,
}: Props): React.ReactElement {
  const classes = useStyles()

  return (
    <Breadcrumbs className={classes.breadcrumbs} separator={<ChevronRight />}>
      {breadcrumbs.map((breadcrumb) => (
        <Typography
          key={breadcrumb.name}
          variant="subtitle2"
          className={classes.breadcrumb}
        >
          {breadcrumb.name}
        </Typography>
      ))}
    </Breadcrumbs>
  )
}
